module.exports = __webpack_public_path__ + "static/media/default_img.0781d6f2.jpg";